$(document).ready(function() {
  // Tato funkce dále není třeba
  /*
    if ($(window).width() < 1300){
        $('.float-nav-header').css({'width': $('.component-FloatNav ul').height(), 'margin-left': - $('.component-FloatNav ul').height()});
    }
    */

  // Tato funkce uz neni treba, nahradila ji funkce scroll

  $(document).on("click", ".component-FloatNav a li", function() {
    $(this)
      .parent()
      .addClass("active");
    $(this)
      .parent()
      .siblings()
      .removeClass("active");
  });

  $(document).on("click", ".float-nav-header a li", function() {
    if ($(".component-FloatNav").hasClass("closed")) {
      $(".component-FloatNav").removeClass("closed");
    } else {
      $(".component-FloatNav").addClass("closed");
    }
  });

  $(window)
    .scroll(function() {
      // urcuje od kdy se stava menu plovoucím
      var fixedComponentFloatNav = 209;
      //pokud tlacitko koupit nelze videt
      var KoupitButtonHide = 750;
      // fixuje dolni a horní hranici obrazovky
      var screenFixBottom = $(window).height() * 0.9071504; //850;
      var screenFixTop = 100;
      // pouhopouha pomucka pro vypis
      var index = 0;

      var $window = $(window);
      var scrollScreenTop = $window.scrollTop() - screenFixTop;
      var scrollScreenBottom =
        $window.scrollTop() + $(window).height() - screenFixBottom;

      //console.log("Top screen: " + $window.scrollTop());
      //console.log("Bottom screen: " + scrollScreenBottom);

      //Plovouci scroll navigator od 170 jinak ma absolutní pozici
      if ($(window).scrollTop() >= fixedComponentFloatNav) {
        $(".component-FloatNav").addClass("fixed-component-FloatNav");
      } else {
        $(".component-FloatNav").removeClass("fixed-component-FloatNav");
      }

      //pokud tlacitko koupit nelze videt
      if ($(window).scrollTop() >= KoupitButtonHide) {
        $(".flout-nav-fadeout").addClass("flout-nav-fadein");
        //$('.float-nav-li').addClass('float-nav-li-top');
        //$('.text-align-custom').addClass('text-align-center');
      } else {
        $(".flout-nav-fadeout").removeClass("flout-nav-fadein");
        //$('.float-nav-li').removeClass('float-nav-li-top');
        //$('.text-align-custom').removeClass('text-align-center');
      }

      //po prejezdu dolu nahoru meni aktivni
      $(".page-section").each(function(i) {
        //index = index + 1;
        //console.log(index + " -- " + ":  " + $(this).position().top + " Top screen: " + scrollScreenTop + " Bot screen: " + scrollScreenBottom);
        //console.log("veliksot obr: " + $(window).height());

        if (
          /*$(this).position().top >=
          scrollScreenTop  &&*/ $(
            this
          ).position().top <= scrollScreenBottom
        ) {
          //vsem kteří jsou aktivní zruší aktivitu
          $(".component-FloatNav a li.active").removeClass("active");
          //ti poslednimu v rade ktery splnuje podminku prida aktivitu
          $(".component-FloatNav a li")
            .eq(i)
            .addClass("active");
        }
      });
    })
    .scroll();
});
